<div id="layoutSidenav">
    <div id="layoutSidenav_content">
        <main>

            <div class="container-fluid px-5 pt-5 mt-4">
                <!-- Total Leads Section -->
                <!-- Coupon Banner -->


                <h2 class="mb-4">Sales({{leads.length}})</h2>
                <ng-container *ngIf="type === 'franchise' || type === 'subfranchise'">
                    Staff:
                    <select name="staff" [(ngModel)]="staffName" (change)="selectStaff($event)">
                        <option value="0">Select Value</option>
                        <option *ngFor="let staff of allStaffRecords; let i = index" [value]="staff.franchiseId">
                            {{ staff.personalDetails.firstName }}
                        </option>
                    </select>
                </ng-container>&nbsp;<br />



                <!-- Data Table -->
                <div class="table-responsive thtdfix">
                    <table class="table table-hover">
                        <thead class="table-primary">
                            <tr>
                                <th>S.No</th>
                                <th>Lead ID</th>
                                <th>Product</th>
                                <th>Customer</th>
                                <th>Contact No</th>
                                <th>Sale Value</th>
                                <th>MFU-Share</th>
                                <th>PB-Share</th>
                                <th>Status</th>
                                <th>Remarks</th>
                                <th> Settled On</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let leadRec of leads; let i = index">
                                <tr>
                                    <td>{{ i + 1 }}</td>
                                    <td>{{ leadRec?.leadId }}</td>
                                    <td>{{leadRec?.product }}</td>
                                    <td>{{leadRec?.customerName}}</td>
                                    <td>{{ leadRec?.mobile }}</td>
                                    <td>{{ leadRec?.actualCost }}</td>
                                    <td>{{ leadRec?.mfuShare}}</td>
                                    <td>{{ leadRec?.pbShare}}</td>
                                    <td><span *ngIf="leadRec?.salesStatus === 0">Open</span><span
                                            *ngIf="leadRec?.salesStatus === 1">Closed</span></td>
                                    <td>
                                        <span [title]="leadRec?.remarks" style="cursor: pointer;"
                                            [ngClass]="getStatusClass(leadRec?.remarks)">
                                            {{ leadRec?.remarks?.length > 20 ? (leadRec?.remarks | slice:0:20) + '...' :
                                            leadRec?.remarks || 'Sales Lead' }}
                                        </span>
                                        <!-- Add any action buttons here -->
                                    </td>
                                    <td>
                                        {{ leadRec?.settledOn | date:'short':'IST'}}
                                        <!-- Add any action buttons here -->
                                    </td>
                                    <td>   <button class="btn btn-sm btn-outline-primary me-2"   (click)="toggleRow(i)"><i class="fa-solid fa-clock-rotate-left"></i></button></td>
                                </tr>
                                <ng-container *ngIf="expandedIndex === i">
                                    <tr class="leads-btns">
                                        <!-- <button class="btn btn-outline-light me-2"
                            (click)="typeServices(this.lookupModel.getLoggedUser().type,'realEstate')">Real Estate
                            (0)</button>
                        <button class="btn btn-outline-light me-2"
                            (click)="typeServices(this.lookupModel.getLoggedUser().type,'finTech')">FinTech (0)</button>
                        <button class="btn btn-outline-light me-2"
                            (click)="typeServices(this.lookupModel.getLoggedUser().type,'propService')">Prop Services
                            (0)</button> -->
                                        <td> <button class="btn me-2" [ngClass]="{
                                'btn-gold': logsType === 'leadLogs',
                                'btn-outline-light': logsType !== 'leadLogs'}" (click)="changeLogsType('leadLogs', i)">
                                                Lead Logs
                                            </button></td>
                                        <td>
                                            <button class="btn me-2" [ngClass]="{
                                'btn-gold': logsType === 'followupLogs',
                                'btn-outline-light': logsType !== 'followupLogs'}"  (click)="changeLogsType('followupLogs', i)">
                                                Followup Logs
                                            </button>
                                        </td>
                                        <td>
                                            <button class="btn me-2" [ngClass]="{
                                'btn-gold': logsType === 'opportunityLogs',
                                'btn-outline-light': logsType !== 'opportunityLogs'}"  (click)="changeLogsType('opportunityLogs', i)">
                                                Opportunity Logs
                                            </button>
                                        </td>

                                    </tr>

                                    <tr>
                                        <td colspan="12" class="bg-light">
                                            <div class="p-2 border w-75 bg-white rounded-1 m-auto text-wrap td-data">
                                                <a (click)="toggleRow(i)" style="cursor: pointer;"><i
                                                        class="fa-solid fa-chevron-up text-right d-block mb-2"></i> </a>
                                                <p *ngFor="let history of childData" class="mb-1">
                                                    <b>{{history.createdAt | date:'short':'IST'}}:</b>
                                                    {{history.remarks || history.description}}- <b>Status</b>: <b class="text-primary"
                                                        style="color: green;">{{getOppStatusName(history.opportunityStatus) || getStatusName(history.status) || 'Verified Lead'}}
                                                    </b>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </main>

    </div>
</div>